




















import Vue, { PropType } from 'vue';
import { DashboardIsland } from '../..';
import FilterMultiSelectDropdown from './FilterMultiSelectDropdown.vue';
import FilterItems from './FilterItems.vue';

interface FilterMultiSelectDropdownInterface extends Vue {
  clear(): void;
  removeItem(value: string): void;
}

export default Vue.extend({
  name: 'Filters',
  methods: {
    clear() {
      (this.$refs.filterSelector as FilterMultiSelectDropdownInterface).clear();
    },
    removeItem(value: string) {
      (this.$refs.filterSelector as FilterMultiSelectDropdownInterface).removeItem(value);
    },
  },
  components: {
    DashboardIsland,
    FilterMultiSelectDropdown,
    FilterItems,
  },
  props: {
    options: {
      type: Array as PropType<string[]>,
      default: () => ([]),
    },
    label: String,
    resetAllLabel: String,
  },
  data() {
    return {
      value: [], // selected items
    };
  },
});
